// extracted by mini-css-extract-plugin
export default {"layout":"index_layout_jKQ9W","bg1":"index_bg1_ZPehx","bg2":"index_bg2_Z-qwh","content":"index_content_hCeZL","container":"index_container_iJJRn"};